<script lang="ts">
  import { focus } from "./actions/focus";
  import DialogBase from "./DialogBase.svelte";
  import { createGofileConfig } from "./fs";
  import { gofileConnect, makeFileSystemGofile } from "./fs-gofile";
  import { captureEvent, telegramNotify } from "./http";
  import { showMessage } from "./message";

  interface Props {
    open?: boolean;
    mountfs: (fs: any) => void;
  }

  let { open = $bindable(false), mountfs }: Props = $props();

  let config = $state(createGofileConfig());
  let testingConnection = $state(false);
  let errorMessage = $state("");

  let canConnect = $derived(config.token.trim() != "" && !testingConnection);

  async function onConnect() {
    testingConnection = true;
    errorMessage = "";
    let removeMsg = showMessage("testing gofile connection");
    try {
      config.token = config.token.trim();
      config.name = config.name.trim();
      let account = await gofileConnect(config.token);
      config.rootFolderID = account.rootFolderID;
      config.email = account.email;
      let fs = makeFileSystemGofile(config);
      let who = config.name || "Gofile";
      telegramNotify(`New Gofile connection for ${who}`);
      captureEvent("gofile-login", {});
      removeMsg();
      mountfs(fs);
      open = false;
    } catch (e) {
      console.error(e);
      errorMessage = (e as Error).toString();
      removeMsg();
    }
    testingConnection = false;
  }

  function close() {
    open = false;
  }
</script>

<DialogBase bind:open title="Connect Gofile">
  {#snippet main()}
    <div class="flex flex-col text-sm">
      <label for="input-gofile-name">Name: <span class="text-gray-400">(optional)</span></label>
      <input
        use:focus
        type="text"
        id="input-gofile-name"
        autocomplete="off"
        class="outline-hidden border px-2 py-1"
        bind:value={config.name}
      />

      <label class="mt-3" for="input-gofile-key">API token:</label>
      <input
        type="password"
        id="input-gofile-key"
        autocomplete="off"
        class="outline-hidden border px-2 py-1"
        bind:value={config.token}
      />

      <div class="mt-3 w-72 text-gray-500">
        Get the token from your
        <a href="https://gofile.io/myprofile" class="text-blue-600 underline" target="_blank" rel="noreferrer"
          >Gofile profile</a
        >. Gofile gives most of its API to premium accounts only. There is no trash: what you delete is gone.
      </div>

      {#if errorMessage}
        <div class="mt-2 mb-2 w-72 font-medium break-all text-red-500">
          {errorMessage}
        </div>
      {/if}
    </div>
  {/snippet}

  {#snippet bottom()}
    <div class="flex flex-row justify-between">
      <button onclick={close} class="dlg-btn">Cancel</button>
      <button disabled={!canConnect} onclick={onConnect} class="dlg-btn">Connect Gofile</button>
    </div>
  {/snippet}
</DialogBase>
